import { ITreeGroup, ITreeLeaf } from './tree.types'

const arrToKeyArray = <T extends Record<string, any>, Key extends keyof T>(
  items: T[],
  key: Key
): Record<T[Key], T[]> => {
  const itemsToMap: Record<T[Key], T[]> = {} as any

  for (const item of items) {
    if (Array.isArray(itemsToMap[item[key]])) {
      itemsToMap[item[key]].push(item)
    } else if (item[key]) {
      itemsToMap[item[key]] = [item]
    }
  }

  return itemsToMap
}

const buildGroupIdToLeafsMap = <T extends Record<string, any>, GroupID extends string | number>(
  leafs: ITreeLeaf<T, GroupID>[]
) => {
  return arrToKeyArray(leafs, 'groupId')
}

const buildGroupIdToGroupsMap = <T extends Record<string, any>, ID extends string | number>(
  groups: ITreeGroup<T, ID>[]
) => {
  return arrToKeyArray(groups, 'parentId')
}

// Возвращает мапу с путями к группам
const convertGroupsToLocation = (
  groups: {
    id: number
    name: string
    parentId: number | null
  }[]
): Record<string, { title: string; parentId: number; id: number }> => {
  const groupsMap = {}

  for (let i = 0; i < groups.length; i++) {
    groupsMap[groups[i].id] = {
      title: `/${groups[i].name}`,
      parentId: groups[i].parentId,
      id: groups[i].id,
    }
  }

  for (const id in groupsMap) {
    const item = groupsMap[id]
    if (item.parentId) {
      groupsMap[id] = {
        ...item,
        title: groupsMap[item.parentId].title + item.title,
      }
    }
  }

  return groupsMap
}

const countLeafsInGroups = <T extends Record<string, any>, K extends string | number>(
  leafsGroupsIds: K[],
  groups: T[]
) => {
  const leafsMap: Record<K, number> = {} as any
  const groupMap: Record<string, any> = {}

  const resultMap: Record<K, number> = {} as any

  for (let i = 0; i < leafsGroupsIds.length; i++) {
    if (!leafsMap[leafsGroupsIds[i]]) {
      leafsMap[leafsGroupsIds[i]] = 1
    } else {
      leafsMap[leafsGroupsIds[i]] = leafsMap[leafsGroupsIds[i]] + 1
    }
  }

  for (let i = 0; i < groups.length; i++) {
    groupMap[groups[i].id] = groups[i]
  }

  for (const key in leafsMap) {
    let group = groupMap[key]
    resultMap[key] = leafsMap[key]

    while (group.parentId) {
      if (resultMap[group.parentId]) {
        resultMap[group.parentId] = resultMap[group.parentId] + leafsMap[key]
      } else {
        resultMap[group.parentId] = leafsMap[key]
      }
      group = groupMap[group.parentId]
    }
  }

  return resultMap
}

const treeUtils = {
  buildGroupIdToLeafsMap,
  buildGroupIdToGroupsMap,
  convertGroupsToLocation,
  countLeafsInGroups,
  arrToKeyArray,
}
export default treeUtils
